const Calendar = ({ color, type }) => {
  const solid = (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 18.6667V4.66675C18 3.56375 17.103 2.66675 16 2.66675H14V0.666748H12V2.66675H6V0.666748H4V2.66675H2C0.897 2.66675 0 3.56375 0 4.66675V18.6667C0 19.7697 0.897 20.6667 2 20.6667H16C17.103 20.6667 18 19.7697 18 18.6667ZM6 16.6667H4V14.6667H6V16.6667ZM6 12.6667H4V10.6667H6V12.6667ZM10 16.6667H8V14.6667H10V16.6667ZM10 12.6667H8V10.6667H10V12.6667ZM14 16.6667H12V14.6667H14V16.6667ZM14 12.6667H12V10.6667H14V12.6667ZM16 7.66675H2V5.66675H16V7.66675Z"
        fill={color}
      />
    </svg>
  );
  const regular = (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 20.6667H16C17.103 20.6667 18 19.7697 18 18.6667V4.66675C18 3.56375 17.103 2.66675 16 2.66675H14V0.666748H12V2.66675H6V0.666748H4V2.66675H2C0.897 2.66675 0 3.56375 0 4.66675V18.6667C0 19.7697 0.897 20.6667 2 20.6667ZM16 6.66675L16.001 18.6667H2V6.66675H16Z"
        fill={color}
      />
    </svg>
  );
  const getSVGByType = (type) => {
    switch (type) {
      case "solid":
        return solid;
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Calendar;
